import { ONE_MEBIBYTE } from '@lucidlink/uicore';
// This must be the name of the html file that
// contains the second entry point to the project
export const FILE_PREVIEW_HTML_FILE_NAME = 'file-preview.html';
export const FILE_PREVIEW_HTML_LOCATION = `/${FILE_PREVIEW_HTML_FILE_NAME}`;
export const FILE_PREVIEW_FILE_ENDPOINT = 'file-preview-request';
export const FilePreviewUrlSearchParams = {
    FsEntryExtension: 'fsEntryExtension',
    FsEntryId: 'fsEntryId',
    FsEntryName: 'fsEntryName',
    FsEntrySize: 'fsEntrySize',
};
export const MAXIMUM_REQUESTED_RANGE_SIZE = BigInt(10 * ONE_MEBIBYTE);
export const CONCURRENT_DOWNLOAD_SIZE_THRESHOLD = BigInt(5 * ONE_MEBIBYTE);
// eslint-disable-next-line unicorn/prefer-export-from -- I want a new export, not a re-export
export const DEFAULT_STREAM_CHUNK_SIZE = ONE_MEBIBYTE;
